import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Route, Switch } from "react-router-dom";

import { EntityType } from "@mapmycustomers/shared";

import Path from "@app/enum/Path";
import { setEntityTypesWithExternalPreview } from "@app/store/entityView/actions";

import CompanyListPage from "./CompanyListPage";
import CompanyRecordPage from "./CompanyRecordPage";
import FilePage from "./FilePage";

interface Props {
  setEntityTypesWithExternalPreview: typeof setEntityTypesWithExternalPreview;
}

const CompanyPage: React.FC<Props> = ({ setEntityTypesWithExternalPreview }) => {
  useEffect(() => {
    setEntityTypesWithExternalPreview([EntityType.COMPANY]);
    return () => {
      setEntityTypesWithExternalPreview([]);
    };
  }, [setEntityTypesWithExternalPreview]);

  return (
    <Switch>
      <Route path={`${Path.COMPANY}/:cid/files/:fileId`} component={FilePage} />
      <Route>
        <CompanyListPage />
        <Route path={`${Path.COMPANY}/:cid?`} component={CompanyRecordPage} />
      </Route>
    </Switch>
  );
};

const mapDispatchToProps = {
  setEntityTypesWithExternalPreview,
};

export default connect(null, mapDispatchToProps)(CompanyPage);
